module.exports = __webpack_public_path__ + "img/game-developement-main.f360294f.webp";